import { render, staticRenderFns } from "./PauseReason.vue?vue&type=template&id=9f9cf2cc&scoped=true&"
import script from "./PauseReason.vue?vue&type=script&lang=js&"
export * from "./PauseReason.vue?vue&type=script&lang=js&"
import style0 from "./PauseReason.vue?vue&type=style&index=0&id=9f9cf2cc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f9cf2cc",
  null
  
)

export default component.exports